import classNames from 'classnames'
import React from 'react'
import { isMobile } from 'react-device-detect'

export const ShortFormTooltip = (props: any) => {
  const { setShortFormTooltip } = props

  const handleModal = () => {
    setShortFormTooltip((prev: boolean) => !prev)
  }

  const handleMoveLink = (url: string) => {
    if (url) {
      window.open(url, '_blank')
    }
  }

  return (
    <div
      className={classNames(
        'flex flex-col p-[16px] md:p-[32px] gap-[10px] bg-white    absolute border-[3px] border-main  rounded-[20px] ',
        {
          'w-[330px] top-0 left-0 z-50': !isMobile,
          'w-[280px] bottom-5 -left-32': isMobile,
        }
      )}
    >
      <p className=" md:leading-[19.2px] md:text-base  leading-[12px] text-[10px] flex justify-between items-center">
        <span className="font-bold text-[18px]">패스트클릭 약관</span>
        <button className="" type="button" onClick={handleModal}>
          <img
            src="assets/img/Icon_x.png"
            alt="icon_x"
            height={24}
            width={24}
          />
        </button>
      </p>
      <p className="text-left">
        회사는 이용자가 생성한 영상으로 이동하는 링크 등을 쉽게 검색할 수 있도록
        하는 페이지를 제공하는 서비스(이하 "링크 서비스")를 유료 상품 사용자에게
        제공할 수 있으며, 링크 서비스의 제공기간은 유료 상품이 기간 만료나 해지
        등으로 인하여 종료된 경우 같이 종료되나, 회사는 사용자의 유료 상품의
        종료 이후에도 회사의 선택에 따라 회사가 정하는 일정 기간 동안 회사가
        정하는 정책에 따라 일시적으로 더 제공할 수 있습니다.
      </p>

      <p
        className="flex gap-2  text-[14px] items-center cursor-pointer"
        onClick={() => {
          handleMoveLink(
            'https://angelleague.notion.site/ec17eac5961e43b9b49e335e88da14ab?source=copy_link'
          )
        }}
      >
        <span className="text-href  ">서비스 약관 전체보기 {`>`}</span>{' '}
      </p>
    </div>
  )
}
